module.exports = __webpack_public_path__ + "static/gong-4beca676bd89473d1e5d9347ccbea306.jpg";